module.exports = __webpack_public_path__ + "img/logo-horizontal.9187caf8.png";